import * as React from 'react';

import { BaseExercisePage } from '../baseExercisePage';
import { Depth } from './depth';
import * as Edge from '../../../core';
import DepthResults from './results';
import DepthConfigForm from './configForm';

export default class DepthPage extends BaseExercisePage<
	Edge.Models.DepthExerciseConfiguration,
	Edge.Models.DepthExerciseResult
> {
	protected renderConfiguration(): JSX.Element {
		const { lockConfiguration, operationName, mode } = this.props;
		const { configuration } = this.state;

		return (
			<DepthConfigForm
				mode={mode}
				onSubmit={this.startExercise}
				initialConfiguration={configuration}
				lockConfiguration={lockConfiguration}
				operationName={operationName}
			/>
		);
	}
	protected renderExercise(): JSX.Element {
		const { currentProfile, mode } = this.props;
		const { configuration, fullScreen } = this.state;

		return (
			<Depth
				mode={mode}
				debugMode={this.props.debugMode}
				renderScale={currentProfile.renderScale}
				touchControls={currentProfile.touchControls}
				fullScreen={fullScreen!}
				completeExercise={this.finishExercise}
				abortingExercise={this.abortingExercise}
				configuration={configuration}
			/>
		);
	}
	protected renderResults(): JSX.Element {
		const { hideExerciseResults } = this.props;

		return (
			<DepthResults
				results={this.state.result!}
				complete={this.complete}
				retry={this.retryExercise}
				completeText={this.props.completeText}
				hideExerciseResults={hideExerciseResults}
			/>
		);
	}
}
